import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Bill Number', value: 'bill_num' },
  { text: 'Kode Iuran', value: 'kode_iuran'},
  { text: 'Merchant Name', value: 'merchant_name' },
  { text: 'MID', value: 'mid'},
  { text: 'Merchant PAN', value: 'mpan' },
  { text: 'Reff ID', value: 'rrn' },
  { text: 'QR Method', value: 'qr_method' },
  { text: 'QR Type', value: 'qr_type' },
  { text: 'Transaction Type', value: 'trx_type'},
  { text: 'Issuer Name', value: 'issuer_name'},
  { text: 'Customer PAN', value: 'customer_pan'},
  { text: 'Customer Name', value: 'customer_name'},
  { text: 'Payment Type', value: 'payment_type'},
  { text: 'Acquirer Name', value: 'acquirer_name'},
  { text: 'Amount', value: 'amount'},
  { text: 'JHT', value: 'jht'},
  { text: 'JKK', value: 'jkk'},
  { text: 'JKM', value: 'jkm'},
  { text: 'JP', value: 'jp'},
  { text: 'JKP', value: 'jkp'},
  { text: 'MDR', value: 'amount_mdr'},
  { text: 'Net Amount', value: 'amount_net'},
  { text: 'Transaction Date', value: 'trx_datetime'},
  { text: 'Status', value: 'status'},
  { text: 'Settlement Status', value: 'settlement_status'},
  { text: 'Settlement Date', value: 'settlement_at'},
  { text: 'Source of Fund', value: 'payment_method'},
  { text: 'Action', value: 'action', align: 'center', textAlign: 'text-center', width: '10' },
]);

export const search = {
  bill_num: '',
  kode_iuran: '',
  merchant_name: '',
  mid: '',
  mpan: '',
  rrn: '',
  qr_method: '',
  qr_type: '',
  trx_type: '',
  issuer_code: '',
  customer_pan: '',
  payment_method: '',
  customer_name: '',
  payment_type: '',
  payment_channel: '',
  trx_datetime: [],
  status: '',
  settlement_status: '',
};

export const editedItem = {
  bill_num: '',
  kode_iuran: '',
  merchant_name: '',
  mid: '',
  mpan: '',
  rrn: '',
  qr_method: '',
  qr_type: '',
  trx_type: '',
  customer_pan: '',
  payment_method: '',
  payment_type: '',
  payment_channel: '',
  amount: '',
  currency: '',
  amount_mdr: '',
  net_amount: '',
  trx_datetime: '',
  status: '',
  settlement_status: '',
};
